import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CategoriesSection from "./components/CategoriesSection";
import FeaturedSection from "./components/FeaturedSection";
import RoutesSection from "./components/RoutesSection";
import NearbySection from "./components/NearbySection";
import CampaignsSection from "./components/CampaignsSection";
import EventsSection from "./components/EventsSection";
import FooterSection from "./components/FooterSection";
import StickyMapButton from "./components/StickyMapButton";
import ChatbotWidget from "./components/ChatbotWidget";
import WeatherSection from "./components/WeatherSection";
import BursaNewsSection from "./components/BursaNewsSection";
import CityServicesSection from "./components/CityServicesSection";

export default function Home() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <div className="min-h-screen bg-white font-body">
      <Navbar />
      <main>
        <HeroSection />
        <CategoriesSection />
        <FeaturedSection />
        <RoutesSection />
        <NearbySection />
        <EventsSection />
        <CampaignsSection />
        <WeatherSection />
        <BursaNewsSection />
        <CityServicesSection />
      </main>
      <FooterSection />
      <StickyMapButton />
      <ChatbotWidget />
    </div>
  );
}
